import { type ApiClientResponse, apiClient, routes } from 'common/services';
import type {
  CommunityEventContentObjectDataObject,
  EventContentObjectDataObject,
  ProgramEventDataObject,
  PublicEventContentObjectDataObject,
} from 'models/service';

type EventParams = {
  invitation_token?: string;
};

export const getEvent = async <
  T extends
    | CommunityEventContentObjectDataObject
    | EventContentObjectDataObject
    | ProgramEventDataObject
    | PublicEventContentObjectDataObject,
>(
  id: string,
  params?: EventParams,
) =>
  apiClient.get<T, ApiClientResponse<T>>(routes.events.get(id), {
    params,
  });
